import gql from 'graphql-tag';

export const UPDATE_INSURANCE_MUTATION = gql`
  mutation updateInsurance($insuranceInputDetails: InsuranceInput!) {
    updateInsurance(insuranceInput: $insuranceInputDetails) {
      id
      testatorId
      nominatedBeneficiaryCoverRequired
      estateAdminExpensesCoverRequired
      smoker
      educationLevel
      replacementPolicy
      monthlyIncome
      skipInsurance
      monthlyPremiumQuoted
      yearlyPremiumQuoted
      subscriptionType
      rootPolicyNumber
      rootSumAssured
      bankDetails {
        id
        accountHolderName
        bankName
        branchCode
        accountNumber
        debitOrderDay
      }
    }
  }
`;

export const CREATE_OR_UPDATE_BANK_DETAILS_MUTATION = gql`
  mutation createOrUpdateBankDetails(
    $bankDetailsInputDetails: BankDetailsInput!
  ) {
    createOrUpdateBankDetails(bankDetailsInput: $bankDetailsInputDetails) {
      id
      accountHolderName
      bankName
      branchCode
      accountNumber
      debitOrderDay
    }
  }
`;

export const INSURANCE_QUOTE_MUTATION = gql`
  mutation insuranceQuote($insuranceId: ID!) {
    insuranceQuote(insuranceId: $insuranceId) {
      monthlyQuote {
        premiumInRand
        ageEscalationPremium {
          year
          totalPremiumMonthly
          totalPremiumYearly
        }
      }
      yearlyQuote {
        premiumInRand
        ageEscalationPremium {
          year
          totalPremiumMonthly
          totalPremiumYearly
        }
      }
      insurance {
        id
        testatorId
        nominatedBeneficiaryCoverRequired
        estateAdminExpensesCoverRequired
        smoker
        educationLevel
        replacementPolicy
        monthlyIncome
        skipInsurance
        monthlyPremiumQuoted
        yearlyPremiumQuoted
        subscriptionType
        rootPolicyNumber
        rootSumAssured
        bankDetails {
          id
          accountHolderName
          bankName
          branchCode
          accountNumber
          debitOrderDay
        }
      }
    }
  }
`;

export const CREATE_POLICY_MUTATION = gql`
  mutation createPolicy($insuranceId: ID!) {
    createPolicy(insuranceId: $insuranceId) {
      id
      testatorId
      nominatedBeneficiaryCoverRequired
      estateAdminExpensesCoverRequired
      smoker
      educationLevel
      replacementPolicy
      monthlyIncome
      skipInsurance
      monthlyPremiumQuoted
      yearlyPremiumQuoted
      subscriptionType
      rootPolicyNumber
      rootSumAssured
      bankDetails {
        id
        accountHolderName
        bankName
        branchCode
        accountNumber
        debitOrderDay
      }
    }
  }
`;

export const GET_INSURANCE_QUOTES_MUTATION = gql`
  mutation requestQuotes($insuranceId: ID!) {
    requestQuotes(insuranceId: $insuranceId) {
      quotes {
        version
        productCode
        coverAmount
        coverLimit
        monthlyPremium
        childrenQuotes
        requestBody
        tier
        name
        capitalGainsTaxAmount
        combinedTaxAssistAmount
        taxAssistAmount
      }
      startLeadBody
    }
  }
`;

export const START_LEAD_MUTATION = gql`
  mutation startLead($insuranceId: ID!) {
    startLead(insuranceId: $insuranceId) {
      leadStart {
        redirectUrl
        redirectUrlExpiry
        leadId
        spId
        newTab
      }
    }
  }
`;
